// extracted by mini-css-extract-plugin
module.exports = {"faqContent":"user_faq_faqContent__oUhdF"};